export const keepFocus = (fn) => (...args) => {
    if (typeof document === 'undefined') {
        return;
    }
    const activeElement = document.activeElement;
    return fn(...args).finally(() => activeElement && activeElement.focus());
};
//# sourceMappingURL=keep-focus.js.map